import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import AuthorUserLink from '../AuthorUserLink';
import CommentTimestamp from '../CommentTimestamp';
import FeaturedTag from '../FeaturedTag';
import s from './BylineBlock.scss';

interface Props {
  className?: string;
}

/**
 * A user link, a timestamp, and a "Featured" tag if the comment is featured.
 *
 * We tend to add this just before the text content of a comment.
 * */
const BylineBlock: React.FC<Props> = ({ className }) => {
  const { comment } = useContext(CommentContext);
  const { isFeatured, user } = comment;

  return (
    <div className={c(s['root'], className)}>
      {user && <AuthorUserLink comment={comment} className={s['userlink']} />}
      <CommentTimestamp className={s['timestamp']} />
      {isFeatured && <FeaturedTag />}
    </div>
  );
};
BylineBlock.displayName = 'BylineBlock';

export default BylineBlock;
